import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ParticipantsTabs } from './ParticipantsList.enums';
import { ParticipantsListProps } from './ParticipantsList.types';
import {
  FILTER_ACCEPTED,
  FILTER_INVITED,
  FILTER_REGISTERED,
  filterParticipants,
} from 'modules/events/basics/utils/participants.utils';

const useParticipantsList = (props: ParticipantsListProps) => {
  const { t } = useTranslation();
  const { participants = [] } = props;
  const { INVITED, REGISTERED } = ParticipantsTabs;

  const [selectedTab, setSelectedTab] = useState<ParticipantsTabs>(REGISTERED);

  const itemsAcceptedCount = useMemo(
    () => filterParticipants(participants, FILTER_ACCEPTED).length,
    [participants],
  );

  const itemsInvited = useMemo(
    () => filterParticipants(participants, FILTER_INVITED),
    [participants],
  );

  const itemsRegistered = useMemo(
    () => filterParticipants(participants, FILTER_REGISTERED),
    [participants],
  );

  const tabsConfig = [
    {
      label: `${t('participantsList_tabsLabel_registered')} [${itemsAcceptedCount}/${itemsRegistered.length}]`,
      value: REGISTERED,
      onClick: () => setSelectedTab(REGISTERED),
    },
    {
      label: `${t('participantsList_tabsLabel_invited')} [${itemsInvited.length}]`,
      value: INVITED,
      onClick: () => setSelectedTab(INVITED),
    },
  ];

  return {
    itemsInvited,
    itemsRegistered,
    selectedTab,
    tabsConfig,
  };
};

export default useParticipantsList;
